import axios from "./axiosSetup";

const authHeaders = (token) =>
  token ? { Authorization: `Token ${token}` } : {};

export const listBabies = async (params, token) => {
  const response = await axios.get("babies/", {
    headers: authHeaders(token),
    params,
  });
  return response.data;
};

export const getBaby = async (id, token) => {
  const response = await axios.get(`babies/${id}/`, {
    headers: authHeaders(token),
  });
  return response.data;
};

export const createBaby = async (data, token) => {
  const response = await axios.post("babies/", data, {
    headers: authHeaders(token),
    skipGlobalErrorHandler: true,
  });
  return response.data;
};

export const updateBaby = async (id, data, token) => {
  const response = await axios.put(`babies/${id}/`, data, {
    headers: authHeaders(token),
    skipGlobalErrorHandler: true,
  });
  return response.data;
};

export const dischargeBaby = async (id, data, token) => {
  const response = await axios.post(`babies/${id}/discharge/`, data, {
    headers: authHeaders(token),
    skipGlobalErrorHandler: true,
  });
  return response.data;
};
